import { useConfig } from '../contexts/ConfigContext';
import { API_ROOT as BUILD_TIME_API_ROOT } from '../config';

/**
 * Hook to get API_ROOT from runtime config
 * Falls back to build-time value if config not loaded
 */
export const useApiRoot = () => {
  const { config } = useConfig();
  return config?.apiRoot || BUILD_TIME_API_ROOT;
};
